<template>
  <JoszakiModal
    :open="isModalOpen"
    :title="$t('questionPage.editAnswerModal.title')"
    @close="closeModal"
  >
    <template #body>
      <JoszakiLoading :active="isSaving" />
      <JoszakiTextArea v-model="answerBody" :show-error-msg="false" />
    </template>

    <template #footer>
      <div class="flex flex-1 justify-between">
        <JoszakiButton type="error" @click="closeModal">
          {{ $t("common.cancel") }}
        </JoszakiButton>
        <JoszakiButton type="success" icon-left="check" @click="saveAnswer">
          {{ $t("common.save") }}
        </JoszakiButton>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import {
  MODAL_EDIT_ANSWER,
  useQuestionStore,
} from "~/stores/question/question";

export default {
  name: "EditAnswerModal",
  setup() {
    return {
      questionStore: useQuestionStore(),
    };
  },
  data: () => {
    return {
      answerBody: "",
      isSaving: false,
    };
  },
  computed: {
    isModalOpen() {
      return this.questionStore.isModalOpen(MODAL_EDIT_ANSWER);
    },
    answer() {
      return this.questionStore.modalInput(MODAL_EDIT_ANSWER)?.answer ?? null;
    },
  },
  watch: {
    isModalOpen(newIsOpen) {
      if (newIsOpen) {
        this.answerBody = this.answer.body;
      }
    },
  },
  methods: {
    async saveAnswer() {
      try {
        this.isSaving = true;

        await this.questionStore.updateAnswer(
          Number(this.answer.id),
          this.answerBody
        );

        this.closeModal();
        await this.questionStore.reloadQuestion();
        this.$joszaki.toast({
          message: this.$t("questionPage.editAnswerModal.success"),
          position: "is-top",
          type: "success",
        });
      } catch (e) {
        console.error(e);
        this.$joszaki.toast({
          message: this.$t("questionPage.editAnswerModal.error"),
          position: "is-top",
          type: "danger",
        });
      } finally {
        this.isSaving = false;
      }
    },
    closeModal() {
      this.questionStore.closeModal();
    },
  },
};
</script>
